<template>
  <div class="manage-panel-video-record-container manage-panel-inner-container">
    <el-scrollbar class="video-record-scrollbar inner-scrollbar">
      <div class="item-entity"
        v-for="(item, index) of tableList"
        :key="index"
        @click="entityClick(item)"
        :class="{
          'item-entity-hover': item[clickCheckProp],
        }"
      >
        <div class="title ellipsis">
          {{ item['videoFileName'] }}
        </div>
        <div class="title ellipsis" v-show="item['updateTime']">
          更新时间：{{ item['updateTime'] }}
        </div>
        <!-- <div class="title ellipsis" v-show="item['videoFileTime']">
          目标时间：{{ item['videoFileTime'] }}
        </div> -->
      </div>
    </el-scrollbar>
    <div
      class="page-body"
    >
      <Pagination 
        @pageChange="pageChange"
        :total="total"
        v-model:page="listQuery.page"
        v-model:limit="listQuery.length"
        layouts="total, pager,"
      />
    </div>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, 
  h, defineComponent, toRaw,
} from 'vue';
import store from '@/store';
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';

import Pagination from '@/components/Pagination';

import filmIconUrl from '@/assets/icon/marker/film.png';

import { getAuthLink } from '@/api/UserWorkspaceDataApi';
import { queryShootingLocationList, } from '@/api/ShootingLocationApi';

// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);
const homeMap = computed(() => store.getters.getHomeMap),
      map = toRaw(homeMap.value),
      layerGroup = L.featureGroup().addTo(map),
      layerGroupClose = ()=>{
        map.removeLayer(layerGroup);
      },
      layerGroupClear = ()=>{
        layerGroup.clearLayers();
      }

const iconSize = 24,
      iconSizes = [ iconSize, iconSize ],
      iconAnchor = iconSizes.map(e=> e / 2 );

const clickCheckProp = ref('clickCheck'), layerProp = 'layer';
const entityClick = async (item)=>{
  const layer = item[layerProp] || await filmInit(item);
  item[clickCheckProp.value] = !item[clickCheckProp.value];
  if(item[clickCheckProp.value]){
    layer && layerGroup.addLayer(layer);
    map.setView(layer.getLatLng(), 6);
  }else{
    layer && layerGroup.removeLayer(layer);
  }
}
const filmAppInit = (url)=>{
  return vueCreateAppInit(
    defineComponent({
      setup(){
        return ()=> h('video', {
          controls: false,
          style: { width: '200px', height: '120px' },
          src: url,
          autoplay: true,
          loop: true,
          onClick: click=>{
            const video = click.target;
            video.requestFullscreen?.();
          }
        })
      }
    })
  );
}
const getVideoFile = (name)=>{
  return new Promise((resolve, reject)=>{
    getAuthLink(name).then(res=>{
      if(res.data.code == 1004){
        resolve(res.data.data);
      }else{
        resolve();
      }
    }).catch(err=>{
      resolve();
      console.log(err);
    });
  })
}
const filmInit = async (item)=>{
  const marker = L.marker(item, {
    icon: L.icon({
      iconUrl: filmIconUrl,
      iconSize: iconSizes,
      iconAnchor: iconAnchor,
    })
  });
  const data = await getVideoFile(item['videoFileName']);
  if(data){
    const popupContent = document.createElement('div');
          filmAppInit(data).mount(popupContent)
    marker.bindPopup(popupContent, {
      closeButton: false,
      autoClose: false,
      offset: [ 0, 0 ],
      direction: 'top',
    })
  }
  item[layerProp] = marker;
  return marker;
}

const tableList = ref([])
const total = ref(0),
    listQuery = reactive({
      page: 1,
      length: 20
    })
// 分页器change
const pageChange = ()=>{
  selectList()
}

const selectList = ()=>{
  queryShootingLocationList({
    ...listQuery,
    pager: listQuery,
  }).then(res=>{
    if(res.data.code == 1004){
      tableList.value = res.data.dataList;
      total.value = res.data.totalCount || 0;
    }
  }).catch(err=>{
    console.log(err);
  });
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  selectList();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  layerGroupClose();
});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
// .manage-panel-video-record-container{
//   height: 100%;
//   width: 100%;
//   padding: 8px 5px;
//   .video-record-scrollbar{
//     height: calc(100% - var(--pageHeight));
//     :deep(.el-scrollbar__view){
//       display: flex;
//       flex-direction: column;
//       gap: var(--padDefaultSize);
//     }
//     .record-item-entity{
//       border-radius: var(--borderRadiusSize);
//       padding: var(--padDefaultSize);
//       backdrop-filter: blur(5px);
//       cursor: pointer;
//       &:hover{
//         // border-color: var(--borderColor_6);
//         background-color: var(--backgroundColor_21);
//       }

//     }
//   }
// }
</style>